import { render, staticRenderFns } from "./BnBalesetDijCard.vue?vue&type=template&id=27374478&scoped=true&"
import script from "./BnBalesetDijCard.vue?vue&type=script&lang=js&"
export * from "./BnBalesetDijCard.vue?vue&type=script&lang=js&"
import style0 from "./BnBalesetDijCard.vue?vue&type=style&index=0&id=27374478&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27374478",
  null
  
)

export default component.exports